import { FC } from 'react';
import cn from 'classnames';

import { DropdownSection } from 'components/DropdownSection';
import { Switch } from 'components/ui';

interface RootNodeProps {
  isOpen: boolean;
  title: string;
  counter: string;
  checked: boolean;
  classNames?: { container?: string };
  onOpenToggle: (isOpen: boolean) => void;
  onCheckChange: () => void;
}

export const RootNode: FC<RootNodeProps> = ({
  isOpen,
  title,
  counter,
  checked,
  classNames,
  onOpenToggle,
  onCheckChange,
}) => (
  <div
    className={cn('flex justify-between items-center', classNames?.container)}
  >
    <DropdownSection
      isOpen={isOpen}
      title={title}
      classNames={{ title: 'tpg-b2' }}
      onOpenToggle={onOpenToggle}
    />
    <div className="flex items-center gap-2">
      <span className="tpg-c2 text-tpg_base">{counter}</span>
      <Switch checked={checked} onChange={onCheckChange} />
    </div>
  </div>
);
